/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'../../../lib/@waca/upgrades/UpgradeBase',
	'./utils/WidgetUpgradeUtils',
	'jquery'
], (UpgradeBase, WidgetUpgradeUtils, $) => {

	const LIVE_WIDGET_TYPE = 'live';
	const TEXT_WIDGET_TYPE = 'text';

	class WidgetTitleAriaLabelUpgrade extends UpgradeBase {

		constructor() {
			super();
			this.VERSION = 1402;
		}

		/**
		 * Perform upgrade for the aria label by removing the old one so that the new
     * label will not be duplicated by the new code.
     * This is needed to solve the issue of titles getting duplicate text when
     * being pinned in the dashboard.
     *
     *
     * @param {object} spec - The widget spec that the upgrade is performed on
     *
     * @return {Promise} Promise to be resolved with upgrade performed.
		 */
		up(spec) {
			if (!spec) {
				return Promise.resolve(spec);
			}
			if (!WidgetUpgradeUtils.specHasWidgets(spec)) {
				return Promise.resolve(spec);
			}

			return this._upgradeWidgets(spec);
		}

		_upgradeWidgets(spec) {
			for (var widget in spec.widgets) {
				const model = spec.widgets[widget];
				if (model.titleHtml && model.type == LIVE_WIDGET_TYPE) {
					model.titleHtml = this._upgradeLiveVisualizations(model.titleHtml);
					model.name = this._updateTranslationTable(model.titleHtml);
				} else if (model.type == TEXT_WIDGET_TYPE) {
					model.name = this._updateTranslationTable(model.content);
				}
			}
			return Promise.resolve(spec);
		}

		_generateTitle(html) {
			let $titleHtml = $(html);
			let title = '';
			$titleHtml.find('p, li').each(function(index, el) {
				title = title + ' ' + el.textContent;
			});
			return title.trim();
		}

		_updateTranslationTable(table) {
			let new_table = JSON.parse(JSON.stringify(table));
			if (table.translationTable) {
				for(let locale in table.translationTable) {
					new_table.translationTable[locale] = this._generateTitle(table.translationTable[locale]);
				}
			} else { //No translation table
				new_table = this._generateTitle(table);
			}
			return new_table;
		}

		_removeAriaLabelNode(html) {
			let $titleHtml = $(html);
			let $ariaLabel = $titleHtml.find('.ariaLabelNode');
			$ariaLabel.remove();
			return $titleHtml[0].outerHTML;
		}

		_upgradeLiveVisualizations(titleHtml) {
			if (titleHtml.translationTable) {
				for (let locale in titleHtml.translationTable) {
					titleHtml.translationTable[locale] = this._removeAriaLabelNode(titleHtml.translationTable[locale]);
				}
			} else {
				titleHtml = this._removeAriaLabelNode(titleHtml);
			}
			return titleHtml;
		}
	}

	return new WidgetTitleAriaLabelUpgrade();

});
